"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = register;
var _assign = _interopRequireDefault(require("./assign"));
var TAGS = {
  assign: _assign["default"]
};
function register(engine) {
  for (var _i = 0, _Object$entries = Object.entries(TAGS); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      name = _Object$entries$_i[0],
      tagImpl = _Object$entries$_i[1];
    engine.registerTag(name, tagImpl);
  }
}